// Shared styles for AutoRegisterForm components
// This file contains all styling for the auto-registration form components

// The logic from this file is also used after mail verification in verify.php WEB FRONT END PAGE

export const getLeftPanelStyles = (isCompact, isMobileView) => ({
  leftPanel: {
    background: "linear-gradient(to right, #a3c1fc, #6a8bcc)",
    color: "#fff",
    padding: isMobileView ? "15px 10px" : "40px",
    width: isMobileView ? "calc(100% - 40px)" : (isCompact ? "350px" : "50%"),
    height: "100%",
    display: "flex",
    flexDirection: isMobileView ? "row" : "column",
    alignItems: "center",
    justifyContent: isMobileView ? "space-between" : "space-evenly",
    borderRadius: "40px",
    zIndex: 2
  },
  leftSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "10px",
    maxWidth: isMobileView ? "30%" : "none",
    marginLeft: isMobileView ? '15px' : '0',
  },
  leftTitle: {
    fontSize: isMobileView ? "18px" : "28px",
    marginBottom: isMobileView ? "0" : "10px",
    textAlign: isMobileView ? 'center' : 'left'
  },
  icon: {
    width: isMobileView ? "55px" : "87px",
    height: isMobileView ? "55px" : "87px",
    borderRadius: isMobileView ? '15px' : '20px'
  },
  leftText: {
    fontSize: isMobileView ? "14px" :   "16px",
    lineHeight: "1.5",
    textAlign: isMobileView ? 'left' : 'center',
    flex: isMobileView ? 1 : 'none',
    marginLeft: isMobileView ? '20px' : '0',
    marginTop: '0',
    marginBottom: '0'
  },
});

export const getRightPanelStyles = (isExpanded, isMobile, step) => ({
  rightPanel: {
    backgroundColor: "#fff",
    padding: isExpanded ? "60px 10px" : "60px 40px",
    display: "flex",
    width: isMobile ? "100%" : (isExpanded ? "calc(100% - 350px)" : "50%"),
    height: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "0 40px 40px 0",
    zIndex: 1
  },
  headerSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "20px",
    width: "100%"
  },
  titleContainer: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    width: "100%",
    justifyContent: "center",
    position: "relative"
  },
  backButton: {
    position: "absolute",
    left: "0",
    top: isMobile && step >= 3 ? "-35px" : "auto",
    border: "1px solid #CCDCFC",
    color: "#A6ADBD",
    fontSize: "24px",
    cursor: "pointer",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "51px",
    height: "30px",
    transition: "background-color 0.2s ease",
    boxShadow: "none",
    outline: "none",
    marginLeft: isMobile && step >= 3 ? "20px" : (isExpanded ? "50px" : "0")
  },
  icon: {
    fontSize: "20px",
    color: "#A6ADBD"
  },
  rightTitle: {
    fontSize: "28px",
    marginBottom: "5px",
    justifyContent: "center",
    textAlign: "center"
  },
  customBlueLine: {
    height: '2px',
    width: '145px',
    backgroundColor: '#407EF9'
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    width: isMobile ? '100%' : '80%'
  },
  bottomSection: {
    display: "flex",
    flexDirection: "column",
    gap: isMobile ? "0" : "15px",
    alignItems: "center",
    marginTop: "auto"
  },
  button: {
    height: "40px",
    fontSize: "16px",
    backgroundColor: "#407EF9",
    color: "#fff",
    border: "none",
    borderRadius: "40px",
    cursor: "pointer",
    width: "100%",
    marginTop: isMobile ? "30px" : "0",
  },
  existingAccount: {
    fontSize: "13px",
    color: "#666",
    textAlign: "center",
    marginTop: isMobile ? "10px" : "5px",
    lineHeight: "1.4"
  },
  existingAccountLink: {
    color: "#407EF9",
    textDecoration: "underline",
    fontWeight: "500",
    cursor: "pointer"
  },
});

export const getStepOneStyles = () => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    marginTop: "20px",
    width: '100%'
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    position: 'relative'
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333"
  },
  input: {
    width: '100%',
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #CCDCFC",
    color: '#A6ADBD',
    borderRadius: "20px",
    height: "40px",
    transition: 'border-color 0.2s ease'
  },
  asterisk: {
    color: 'red',
    marginLeft: '3px'
  },
  errorText: {
    color: '#ff4444',
    fontSize: '12px',
    position: 'absolute',
    bottom: '-20px',
    left: '12px',
    margin: 0
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '-10px'
  },
  checkbox: {
    margin: '0',
    cursor: 'pointer'
  },
  checkboxText: {
    flex: '1',
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.4'
  },
  link: {
    color: '#407EF9',
    fontSize: '14px',
    textDecoration: 'underline',
    fontWeight: '500',
    transition: 'color 0.2s ease'
  },
  linkHover: {
    color: '#2A58B5',
    fontSize: '14px',
    textDecoration: 'underline',
    fontWeight: '500',
    transition: 'color 0.2s ease'
  }
});

export const getStepTwoStyles = () => ({
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    width: '100%'
  },
  inputContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
    position: 'relative'
  },
  label: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333"
  },
  input: {
    width: '100%',
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #CCDCFC",
    color: '#A6ADBD',
    borderRadius: "20px",
    height: "40px",
    transition: 'border-color 0.2s ease'
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '-10px'
  },
  checkbox: {
    margin: '0',
    cursor: 'pointer'
  },
  checkboxText: {
    flex: '1',
    fontSize: '14px',
    color: '#333',
    lineHeight: '1.4'
  },
  link: {
    color: '#407EF9',
    fontSize: '14px',
    textDecoration: 'underline',
    fontWeight: '500',
    transition: 'color 0.2s ease'
  },
  linkHover: {
    color: '#2A58B5',
    fontSize: '14px',
    textDecoration: 'underline',
    fontWeight: '500',
    transition: 'color 0.2s ease'
  },
  asterisk: {
    color: 'red',
    marginLeft: '3px'
  },
  errorText: {
    color: '#ff4444',
    fontSize: '12px',
    position: 'absolute',
    bottom: '-20px',
    left: '12px',
    margin: 0
  }
});

export const getProgressBarStyles = () => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    marginTop: "30px",
  },
  dotsContainer: {
    display: "flex",
    gap: "15px",
  },
  dot: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    backgroundColor: "#ccc",
    transition: "background-color 0.3s ease",
  },
  activeDot: {
    backgroundColor: "#407EF9",
  },
});